<div class="modal-header">
    <h4 class="modal-title"
        id="modal-basic-title">{{'bikeshop.modal.change_my_password.change_password' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span class="hubtiger-close"></span>
    </button>
</div>
<div class="modal-body">
    <form>
        <div class="row margin-top-8">
            <div class="col-md-5 label">*{{'bikeshop.modal.change_my_password.old_password' | translate }}:</div>
            <div class="col-md-7">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><span class="fa fa-lock"></span></span>
                    <input type="password" pInputText [(ngModel)]="oldPassword"
                           placeholder="{{'bikeshop.modal.change_my_password.old_password' | translate }}"
                           autocomplete="new-password" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-5 label">*{{'bikeshop.modal.change_my_password.new_password' | translate }}:</div>
            <div class="col-md-7">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><span class="fa fa-lock"></span></span>
                    <input type="password" pInputText [(ngModel)]="password"
                           placeholder="{{'bikeshop.modal.change_my_password.new_password' | translate }}"
                           autocomplete="new-password" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-5 label">*{{'bikeshop.modal.change_my_password.confirm_password' | translate }}:</div>
            <div class="col-md-7">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><span class="fa fa-lock"></span></span>
                    <input type="password" pInputText [(ngModel)]="confirmPassword"
                           placeholder="{{'bikeshop.modal.change_my_password.confirm_password' | translate }}"
                           autocomplete="new-password" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
        </div>
    </form>
    <div class="margin-top-16" *ngIf="error">
        {{errorMessage}}
    </div>
</div>
<div class="modal-footer">
    <div class="row">
        <div class="col-md-6"></div>
        <div class="col-md-6">
            <button pButton type="button" [disabled]="busy || (password.length<6 || password!==confirmPassword)"
                    class="p-button-raised full-width" (click)="changePassword()"
                    label="{{'bikeshop.modal.change_my_password.change_password' | translate }}"></button>
        </div>
    </div>
</div>
